import { useCallback } from 'react';
import { Banner, showBanner, BannerType } from 'components/Banner';

export const useToastNotification = () => {
  const showBannerDefault = useCallback((
    type: BannerType,
    title: string,
    message?: string,
    durationMillis?: number,
  ) => {
    showBanner(
      (
        <Banner
          type={type}
          title={title}
          message={message}
          durationMillis={durationMillis}
        />
      ), durationMillis,
    );
  }, []);

  const success = useCallback((title: string, message?: string, duration?: number) => {
    showBannerDefault(BannerType.SUCCESS, title, message, duration);
  }, [showBannerDefault]);

  const warning = useCallback((title: string, message?: string, duration?: number) => {
    showBannerDefault(BannerType.WARNING, title, message, duration);
  }, [showBannerDefault]);

  const info = useCallback((title: string, message?: string, duration?: number) => {
    showBannerDefault(BannerType.INFO, title, message, duration);
  }, [showBannerDefault]);

  const error = useCallback((title: string, message?: string, duration?: number) => {
    showBannerDefault(BannerType.ERROR, title, message, duration);
  }, [showBannerDefault]);

  return {
    success,
    warning,
    info,
    error,
  };
};
